import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

import { useMe } from "../../../hooks/queries";
import { AccountType } from "../../../models/AccountData";
import { useFacilityReport } from "../FacilityReportDetails/hook";

interface IFacilityReportDetailsPageProps {
  facilityReportId: string;
}

export const FacilityReportsBackLink: React.FC<
  IFacilityReportDetailsPageProps
> = (props) => {
  const { facilityReportId } = props;

  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityReportsPage.facilityReportsBackLink.${key}`);

  const { data: me } = useMe();
  const accountType = me?.type;

  const { data: facilityReport } = useFacilityReport(facilityReportId);
  const locationId = facilityReport?.location_id;

  // If admin, back link returns to facility reports list
  // If not admin, back link returns to facility details page
  const backLink =
    accountType === AccountType.ADMIN
      ? `/facility-reports`
      : `/location/${locationId}`;
  const backLinkText =
    accountType === AccountType.ADMIN
      ? t("back_to_facility_reports")
      : t("back_to_facility_details");

  return (
    <div className="facility-reports-back-link">
      <NavLink to={backLink} className="back-link">
        <i className="icons icon-back"></i>
        {backLinkText}
      </NavLink>
    </div>
  );
};
